var exports = {
  "_R": "xcc377c0b--2fcaf5--close-button",
  "g2": "xcc377c0b--2fcaf5--aside-info",
  "QE": "xcc377c0b--2fcaf5--object-price",
  "VV": "xcc377c0b--2fcaf5--more-info",
  "kD": "xcc377c0b--2fcaf5--call-button",
};

module.exports = exports;
